export const HamburgerIcon = ({ className }: { className: string }) => {
  return (
    <svg
      className={`stroke-current ${className}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path stroke="currentColor" d="M4 4.5h12M4 9.5h12M4 14.5h12" />
    </svg>
  );
};
